<template>
  <div class="page" v-loading="loading">
    <!-- 头部 start -->
    <Head :tabIndex="0"></Head>
    <!-- 头部 end -->
    <!-- 宽屏显示 -->
    <el-carousel class="hidden-xs-only" height="750px">
      <el-carousel-item v-for="(item,index) in imagesSwiper" :key="index">
        <el-image class="swiperImg" :src="item.thumb" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 小屏显示 -->
    <el-carousel class="hidden-sm-and-up" height="4rem">
      <el-carousel-item v-for="(item,index) in imagesSwiper" :key="index">
        <el-image class="swiperImg" :src="item.thumb" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 订单查询 start -->
    <div class="tracking">Consignment Tracking</div>
    <el-input class="Search" v-model="order_no" placeholder="Search Reference Number"></el-input>
    <el-button @click="TRACK" class="TRACK">TRACK</el-button>
    <!-- 订单查询 end -->
    <div class="more">
      <span class="more-left">About US</span>
      <!-- <div class="more-right">
        <span>more</span>
        <img class="more-icon" src="../../static/home/youjiantou.png">
      </div> -->
    </div>
    <!-- About US start -->
    <img class="video" src="../../static/home/bg2.png">
    <p class="video-text">{{content}}</p>
    <!-- About US end -->
    <!-- Contact us start -->
    <div class="contactUs">
      <div class="title">Contact Us</div>
      <div class="contactUs-row">
        <div class="contactUs-item-title">Your Name</div>
        <el-input class="contactUs-item-input" v-model="name_contact"></el-input>
      </div>
      <div class="contactUs-row">
        <div class="contactUs-item-title">Your Email</div>
        <el-input class="contactUs-item-input" v-model="email_contact"></el-input>
      </div>
      <div class="contactUs-row">
        <div class="contactUs-item-title">Your Mobile No</div>
        <el-input class="contactUs-item-input" v-model="contact"></el-input>
      </div>
      <div class="contactUs-row">
        <div class="contactUs-item-title">Enquiry Type</div>
        <el-select class="contactUs-item-input" v-model="type" placeholder="" no-data-text="no data">
          <el-option v-for="item in SuggestionsType" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="contactUs-row">
        <div class="contactUs-item-title">Message</div>
        <el-input class="contactUs-item-input" v-model="body"></el-input>
      </div>
      <div class="send" @click="submit">send</div>
    </div>
    <!-- Contact us end -->
    <div class="enterprise">
      Cooperative Enterprise
    </div>
    <div class="enterprise-list">
      <img src="../../static/home/bg5.png">
      <img src="../../static/home/bg6.png">
      <img src="../../static/home/bg4.png">
      <img src="../../static/home/bg3.png">
      <img src="../../static/home/bg7.png">
      <img src="../../static/home/bg8.png">
      <img src="../../static/home/bg9.png">
      <img src="../../static/home/bg10.png">
    </div>
    <div class="TopLogistics">© 2021 TE EXPRESS Powered by TE EXPRESS</div>
    <Vcode :show="isShow" @success="codeSuccess" @close="codeClose" successText="Verification passed!"
      failText="Verification failed, please try again" sliderText="Drag the slider to complete the puzzle" />
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode'
export default {
  components: {
    Vcode
  },
  data () {
    return {
      loading: false, // 提交loading
      isShow: false, // 验证码模态框是否出现
      imagesSwiper: [], // 轮播图数组
      SuggestionsType: [], // 意见反馈类型数组
      type: '', // 投诉建议类型名称
      body: '', // 内容
      contact: '', // 联系电话
      email_contact: '', // 邮箱联系方式
      name_contact: '', // 联系人
      order_no: '',
      content: ''
    }
  },
  mounted () {
    document.title = 'Home-TE EXPRESS'
    this.operationGetAds()
    this.operationSuggestionsType()
    this.getArticleDetail()
  },
  methods: {
    // 获取关于我们信息
    getArticleDetail () {
      this.$axios({
        method: 'post',
        url: this.$host + this.$api.getArticleDetail,
        headers: {
          lang: 'en'
        },
        data: {
          id: 17
        }
      }).then(res => {
        if (res.data.code == 1) {
          this.content = res.data.data.synopsis
        }
        // this.SuggestionsType = res.data.data.types;
        console.log(res)
      })
    },
    // 获取意见反馈类型
    operationSuggestionsType () {
      this.$axios({
        method: 'post',
        url: this.$host + this.$api.operationSuggestionsType,
        headers: {
          lang: 'en'
        }
      }).then(res => {
        this.SuggestionsType = res.data.data.types
        console.log(res)
      })
    },
    // 订单提交
    submit () {
      if (this.name_contact == '') {
        this.$message({
          message: 'Please Enter Your Name',
          type: 'warning'
        })
        return false
      }
      if (this.email_contact == '') {
        this.$message({
          message: 'Please Enter Your Email',
          type: 'warning'
        })
        return false
      }
      if (this.name_contact == '') {
        this.$message({
          message: 'Please Enter Your Mobile No',
          type: 'warning'
        })
        return false
      }
      if (this.type == '') {
        this.$message({
          message: 'Please Select Enquiry Type',
          type: 'warning'
        })
        return false
      }
      if (this.body == '') {
        this.$message({
          message: 'Please Select Message',
          type: 'warning'
        })
        return false
      }
      this.isShow = true
    },
    // 验证关闭
    codeClose () {
      this.isShow = false
    },
    // 验证成功提交
    codeSuccess () {
      this.isShow = false
      this.loading = true
      var data = {
        type: this.type, // 投诉建议类型名称
        body: this.body, // 内容
        contact: this.contact, // 联系电话
        email_contact: this.email_contact, // 邮箱联系方式
        name_contact: this.name_contact // 联系人
      }
      this.$axios({
        url: this.$host + this.$api.addSuggestionsOffice,
        method: 'post',
        data: data
      }).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$router.push({
            path: '/ContactUs',
            name: 'ContactUs',
            params: {
              isSuccess: 1
            }
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 获取轮播图
    operationGetAds () {
      this.$axios({
        method: 'post',
        url: this.$host + this.$api.operationGetAds,
        data: {
          typeid: 13,
          lang: 'en'
        }
      }).then(res => {
        this.imagesSwiper = res.data.data
        console.log(res)
      })
    },
    // 搜索
    TRACK () {
      if (this.order_no == '') {
        this.$message({
          message: 'Order No. cannot be blank',
          type: 'wraning'
        })
        return false
      }
      this.$router.push({
        path: '/Tracking',
        name: 'Tracking',
        query: {
          order_no: this.order_no
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .page {
    width: 100%;
    font-size: 12px;
  }

  @media only screen and (min-width:1200px) {
    .swiperImg {
      width: 100%;
      height: 750px;
    }

    /* 订单查询 start */
    .tracking {
      margin-top: 72px;
      text-align: center;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .Search {
      margin: 48px auto 0;
      display: block;
      width: 1200px;
      background: #F6F7F9;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .TRACK {
      width: 234px;
      height: 56px;
      border: 1px solid #EEEEEE;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 8px;
      color: #FFFFFF;
      display: block;
      margin: 88px auto 0;
    }

    /* 订单查询 end */

    .more {
      height: 47px;
      width: 1200px;
      margin: 104px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 1200px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 1200px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */
    .contactUs {
      margin-top: 60px;
      width: 100%;
      height: 1006px;
      background: url(../../static/home/bg13.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      overflow: hidden;
    }

    .title {
      text-align: center;
      height: 50px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 50px;
      color: #FFFFFF;
      opacity: 1;
      margin: 40px auto 0;
    }

    .contactUs-row {
      width: 660px;
      margin: 40px auto 0;
    }

    .contactUs-item-title {
      height: 33px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 33px;
      color: #FFFFFF;
      opacity: 1;
    }

    .contactUs-item-input {
      margin: 20px auto 0;
      width: 660px;
      background: #F6F7F9;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .send {
      margin: 41px auto 0;
      width: 234px;
      height: 56px;
      border: 1px solid #EEEEEE;
      opacity: 1;
      border-radius: 8px;
      text-align: center;
      line-height: 56px;
      color: #FFFFFF;
      font-size: 32px;
    }

    .el-input__inner {
      height: 56px;
    }

    /* Contact us end */
    .enterprise {
      height: 50px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 50px;
      color: #333333;
      opacity: 1;
      text-align: center;
      margin-top: 104px;
      margin-bottom: 45px;
    }

    .enterprise-list {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
    }

    .enterprise-list img {
      width: 278px;
      height: 166px;
      margin-bottom: 29px;
    }

    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }
  }

  @media only screen and (min-width:768px) and (max-width: 1199px) {
    .swiperImg {
      width: 100%;
      height: 750px;
    }

    /* 订单查询 start */
    .tracking {
      margin-top: 72px;
      text-align: center;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .Search {
      margin: 48px auto 0;
      display: block;
      width: 768px;
      background: #F6F7F9;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .TRACK {
      width: 234px;
      height: 56px;
      border: 1px solid #EEEEEE;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 8px;
      color: #FFFFFF;
      display: block;
      margin: 88px auto 0;
    }

    /* 订单查询 end */

    .more {
      height: 47px;
      width: 768px;
      margin: 104px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 768px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 768px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */
    .contactUs {
      margin-top: 60px;
      width: 100%;
      height: 1006px;
      background: url(../../static/home/bg13.png);
      overflow: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      overflow: hidden;
    }

    .title {
      text-align: center;
      height: 50px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 50px;
      color: #FFFFFF;
      opacity: 1;
      margin: 40px auto 0;
    }

    .contactUs-row {
      width: 660px;
      margin: 40px auto 0;
    }

    .contactUs-item-title {
      height: 33px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 33px;
      color: #FFFFFF;
      opacity: 1;
    }

    .contactUs-item-input {
      margin: 20px auto 0;
      width: 660px;
      background: #F6F7F9;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .send {
      margin: 41px auto 0;
      width: 234px;
      height: 56px;
      border: 1px solid #EEEEEE;
      opacity: 1;
      border-radius: 8px;
      text-align: center;
      line-height: 56px;
      color: #FFFFFF;
      font-size: 32px;
    }

    .el-input__inner {
      height: 56px;
    }

    /* Contact us end */
    .enterprise {
      height: 50px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 50px;
      color: #333333;
      opacity: 1;
      text-align: center;
      margin-top: 104px;
      margin-bottom: 45px;
    }

    .enterprise-list {
      max-width: 768px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
    }

    .enterprise-list img {
      width: 278px;
      height: 166px;
      margin-bottom: 10px;
    }

    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }
  }

  @media only screen and (max-width: 767px) {
    .swiperImg {
      width: 100%;
      height: 4rem;
    }

    /* 订单查询 start */
    .tracking {
      margin-top: 0.4rem;
      text-align: center;
      opacity: 1;
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 0.50rem;
      color: #333333;
      opacity: 1;
    }

    .Search {
      margin: 0.32rem auto 0;
      display: block;
      width: 90%;
      background: #F6F7F9;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .TRACK {
      width: 3rem;
      height: 0.88rem;
      border: 1px solid #EEEEEE;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 8px;
      color: #FFFFFF;
      display: block;
      margin: 0.56rem auto 0;
    }

    /* 订单查询 end */

    .more {
      height: 47px;
      width: 90%;
      margin: 0.64rem auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 0.36rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 0.28rem;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 0.1rem;
    }

    .more-icon {
      margin-top: 5px;
      width: 0.12rem;
      height: 0.16rem;
    }

    .video {
      display: block;
      width: 90%;
      margin: 0.24rem auto 0;
    }

    .video-text {
      margin: 0.32rem auto 0;
      width: 90%;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.56rem;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */
    .contactUs {
      width: 100%;
      overflow: hidden;
    }

    .title {
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 0.5rem;
      color: #333;
      opacity: 1;
      margin: 0.4rem 0 0 0.32rem;
    }

    .contactUs-row {
      width: 90%;
      margin: 0.4rem auto 0;
    }

    .contactUs-item-title {
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.33rem;
      color: #333;
      opacity: 1;
    }

    .contactUs-item-input {
      margin: 0.2rem auto 0;
      width: 100%;
      background: #333;
      border: 1px solid #E5E7EB;
      opacity: 1;
      border-radius: 8px;
    }

    .send {
      margin: 0.41rem auto 0;
      width: 3rem;
      height: 0.88rem;
      font-size: 0.32rem;
      line-height: 0.88rem;
      border: 1px solid #EEEEEE;
      opacity: 1;
      border-radius: 8px;
      text-align: center;
      color: #FFFFFF;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
    }

    .el-input__inner {
      height: 0.56rem;
    }

    /* Contact us end */
    .enterprise {
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 0.5rem;
      color: #333333;
      opacity: 1;
      text-align: start;
      margin-left: 0.32rem;
      margin-top: 0.56rem;
      margin-bottom: 0.45rem;
    }

    .enterprise-list {
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
    }

    .enterprise-list img {
      width: 3.2rem;
      height: 1.96rem;
      margin-bottom: 10px;
    }

    .TopLogistics {
      margin: 1.3rem auto;
      text-align: center;
      font-size: 0.2rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.28rem;
      color: #9EA7B7;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue